import React from 'react'
import { Text, View } from 'oio-react'
import { Link } from 'react-router-dom'
import { AddIcon, ArrowRightIcon, MessagesOutline24Icon, SearchIcon } from 'assets/icons'
import { messagesUrl } from 'config/constants/urls'
import { useMe, useOrganization } from 'src/core/graphql/hooks'
import { useGlobalState } from 'src/sites/state'
import ToolsBlock from '~/components/MainMenu/ToolsBlock'

const SidebarActionBlock = () => {
   const { myNotificationCount, theme } = useGlobalState()
   const { me, isLoggedIn } = useMe()
   const { organization } = useOrganization()

   const buttonTextProps = {
      size: '1.5[a-d] 1.8[e-f]',
      color: theme.tmpMainMenuTextColor
   }

   return (
      <View width="100%">
         <View
            paddingBottom="15px">
            {organization.currentUserIsAdmin && (
               <Link to="/-/pages/create">
                  <View display="flex" height="30px" alignItems="center">
                     <View width="20px" paddingLeft="3px" marginRight="13px" opacity="0.5">
                        <AddIcon
                           width="14px"
                           height="14px"
                           strokeWidth="3px"
                           color={theme.tmpButtonTextColor}
                        />
                     </View>
                     <Text {...buttonTextProps}>
                        New Page
                     </Text>
                  </View>
               </Link>
            )}
            {isLoggedIn && (
               <Link to={messagesUrl}>
                  <View display="flex" height="30px" alignItems="center">
                     <View width="20px" paddingTop="3px" marginRight="13px">
                        {!myNotificationCount && (
                           <View opacity="0.5" paddingLeft="3px">
                              <MessagesOutline24Icon
                                 width="14px"
                                 height="14px"
                                 strokeWidth="3px"
                                 color={theme.tmpButtonTextColor}
                              />
                           </View>
                        )}
                        {myNotificationCount && (
                           <View
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              minWidth="18px"
                              height="18px"
                              borderRadius="3px"
                              marginRight="15px"
                              backgroundColor={theme.tmpNotificationBadgeColor}>
                              <Text size="0.9" color={theme.tmpNotificationBadgeTextColor}>
                                 {myNotificationCount}
                              </Text>
                           </View>
                        )}
                     </View>
                     <Text {...buttonTextProps}>
                        Messages
                     </Text>
                  </View>
               </Link>
            )}
            <Link to="/-/search">
               <View display="flex" height="30px" alignItems="center">
                  <View width="20px" paddingLeft="3px" marginRight="13px" opacity="0.5">
                     <SearchIcon
                        width="13px"
                        height="13px"
                        strokeWidth="5px"
                        color={theme.tmpButtonTextColor}
                     />
                  </View>
                  <Text {...buttonTextProps}>
                     Search
                  </Text>
               </View>
            </Link>
         </View>
         <View
            display="flex"
            alignItems="flex-start"
            height={theme.tmpToolbarHeight}
            width="100%"
            paddingTop="15px"
            paddingRight="15px"
            borderTop={`1px solid ${theme.tmpMainMenuLineColor}`}>
            <View
               width="100%"
               display="flex"
               justifyContent="space-between"
               alignItems="center">
               <div>
                  {!isLoggedIn && (
                     <Link to="/account/login">
                        <View display="flex" height="30px" alignItems="center">
                           <View width="20px" paddingLeft="3px" marginRight="13px">
                              <ArrowRightIcon
                                 width="10px"
                                 height="10px"
                                 strokeWidth="5px"
                                 color={theme.tmpButtonTextColor}
                              />
                           </View>
                           <Text {...buttonTextProps}>
                              Login
                           </Text>
                        </View>
                     </Link>
                  )}
                  {isLoggedIn && (
                     <Link
                        to="/-/profile/me">
                        <View
                           display="flex"
                           alignItems="center"
                           height="30px">
                           <View
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              width="16px"
                              height="16px"
                              marginRight="15px"
                              borderRadius="3px"
                              backgroundColor="#aaa"
                              backgroundSize={me.avatarMedia ? 'cover' : '90% 90%'}>
                              <Text size="0.9" weight="bold" color="#fff">
                                 {me.fullName.charAt(0)}
                              </Text>
                           </View>
                           <Text {...buttonTextProps} lineHeight="150%">
                              {me.fullName}
                           </Text>
                        </View>
                     </Link>
                  )}
               </div>
               <ToolsBlock
                  popoverAnchorOriginHorizontal="left"
                  popoverMargin="0px -150px"
               />
            </View>
         </View>
      </View>
   )
}

export default SidebarActionBlock
